<template>
    <div id="content">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"></popup>
        <form action="#">
            <div class="inner">
                <add-button
                        v-if="$_createActionAllowed"
                        :title="'Přidat carousel' | translate"
                        route-name="dashboardCarouselNew">
                </add-button>
                <h1 v-translate>Carousely</h1>
            </div>
            <div class="inner_white">
                <div class="filter">
                    <div class="field_left">
                        <search-input input-class="search" v-model="formFields.search"></search-input>
                    </div>
                  <div class="field_right">
                    <select-box
                        id="typeselect"
                        :options="typeOptions"
                        v-model="formFields.type"
                        ref="typeselectref"
                    >
                      <translate class="translate">Typ carouselu</translate>
                    </select-box>
                  </div>
                  <div class="field_left">
                    <select-box
                        id="showvariantselect"
                        :options="showVariantOptions"
                        v-model="formFields.show_variant"
                        ref="showvariantselectref"
                    >
                      <translate class="translate">Typ výpisu</translate>
                    </select-box>
                  </div>
                  <div class="field_right" v-if="showOperatorFilter">
                    <select-box
                        id="operatorselect"
                        :options="operatorOptions"
                        v-model="formFields.operator"
                        ref="operatorselectref"
                    >
                      <translate class="translate">Operátor</translate>
                    </select-box>
                  </div>
                  <div class="field_left">
                    <select-box
                        id="thematicgroupselect"
                        :options="thematicGroupOptions"
                        v-model="formFields.thematic_group"
                        ref="thematicgroupselectref"
                    >
                      <translate class="translate">Tématická skupina</translate>
                    </select-box>
                  </div>
                  <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
                </div>
                <form action="#">
                    <div class="table_overflow">
                      <table class="vypis vypis_detail" ref="table_with_action_line" v-show="dataLoaded">
                        <thead>
                        <tr>
                            <th class="no_padding drag_drop"></th>
                            <th class="no_padding checkbox"></th>
                            <sorting-table-title
                                    v-for="title in sortingTableTitles"
                                    :key="title.id"
                                    :column="title.column"
                                    :sort="getActiveSort(title.column)"
                                    @changeSorting="changeSorting"
                            >{{ title.name }}
                            </sorting-table-title>
                            <th class="no_padding edit"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <dashboard-carousel-row
                                v-for="entity in entities"
                                :entity="entity"
                                :key="entity.id"
                                :selectedEntities="selectedEntities"
                                @input="select"
                                @updateEntity="updateEntity"
                                @deleteEntity="deleteEntity"
                        ></dashboard-carousel-row>
                        </tbody>
                    </table>
                    </div>
                    <list-action-line
                            :entities="entities"
                            :selected-entities="filteredSelectedEntities"
                            :multiple-action-options="multipleActionOptions"
                            :offset="formFields.offset"
                            :limit="formFields.limit"
                            :total-count="totalCount"
                            @run-multiple-action="runMultipleAction"
                            @limit="setLimit"
                            @offset="setOffset"
                            ref="action_line"
                    ></list-action-line>
                </form>
            </div>
        </form>
    </div>
</template>

<script>
	import DashboardCarouselRow from "@/components/views/dashboardCarousels/DashboardCarouselRow"
	import listActions from "@/components/mixins/list-actions"

	export default {
		name: "DashboardCarouselList",
		components: {DashboardCarouselRow},
		mixins: [listActions],
		data() {
			return {
				moduleName: 'dashboardCarousels',
        entitiesKey: 'dashboard_carousels',
        formFields: {
          operator: null,
          show_variant: null,
          type: null,
          thematic_group: null,
        },
        operatorOptions: [],
        showVariantOptions: [
          { 'id': null, 'text': this.$gettext('Všechny')},
          { 'id': 'WIDE', 'text': this.$gettext("Obrázky na šířku") },
          { 'id': 'PORTRAIT', 'text': this.$gettext("Plakáty na výšku") },
          { 'id': 'ULTRA_WIDE', 'text': this.$gettext("Extra široké položky") },
          { 'id': 'BACKGROUND', 'text': this.$gettext("Pozadí") },
          { 'id': 'TOP_10', 'text': this.$gettext("Top 10") },
        ],
        typeOptions: [
          { 'id': null, 'text': this.$gettext('Všechny')},
          { 'id': 'tips', 'text': this.$gettext('Tipy') },
          { 'id': 'best_rated', 'text': this.$gettext('Nejlépe hodnocené') },
          { 'id': 'last_viewed', 'text': this.$gettext('Naposledy zhlédnuté pořady') },
          { 'id': 'pvrs', 'text': this.$gettext('Nahrávky') },
          { 'id': 'tags', 'text': this.$gettext('Štítky') },
          { 'id': 'favorites', 'text': this.$gettext('Oblíbené') },
          { 'id': 'periodic_pvrs', 'text': this.$gettext('Periodické nahrávky') },
          { 'id': 'custom', 'text': this.$gettext('Obsahový carousel') },
          { 'id': 'channels', 'text': this.$gettext('Kanálový carousel') },
          { 'id': 'last_channels', 'text': this.$gettext('Naposledy zhlédnuté kanály') },
          { 'id': 'menu', 'text': this.$gettext('Menu') },
          { 'id': 'most_viewed_broadcast', 'text': this.$gettext('Nejsledovanější pořady') },
          { 'id': 'top_10_movies', 'text': this.$gettext('Top 10 filmů') },
          { 'id': 'top_10_series', 'text': this.$gettext('Top 10 seriálů') },
        ],
        thematicGroupOptions: [
          { 'id': null, 'text': this.$gettext('Všechny')},
          { 'id': true, 'text': this.$gettext('S tématickou skupinou')},
          { 'id': false, 'text': this.$gettext('Bez tématické skupiny')},
        ]
			}
		},
		created(DashboardCarouselService, OperatorService) {
			this.entityService = DashboardCarouselService;
      this.operatorService = OperatorService;
			this.createdInit()
      if(this.showOperatorFilter) {
        this.operatorService.getOperators().then((data)=>{
          this.operatorOptions = this._.map(data['operators'], function (item) {
            return {id: item['id'], text: item['name']}
          });
          this.operatorOptions.unshift({'id': 'global', 'text':this.$gettext('Pouze globální')});
          this.operatorOptions.unshift({'id': null, 'text':this.$gettext('Všechny')});
        })
      }
		},
		computed: {
      showOperatorFilter(){
        return this.$_loggedUser_action_allowed('operators') && this.$_loggedUser_canChangeOperator && !this.$_loggedUser_isChangedOperator;
      },
      multipleActionOptions() {
        return [
          {value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        ]
      },
      sortingTableTitles() {
        if (this.$_readActionAllowedAllOrOwnAndGlobal) {
          return this.sortingTableTitlesOwner
        } else {
          return this.sortingTableTitlesOperator
        }
      },
			sortingTableTitlesOwner() {
        return [
          {id: 1, name: this.$gettext('Název'), column: 'sName'},
          {id: 2, name: this.$gettext('Operátor'), column: 'sOperatorName'},
          {id: 3, name: this.$gettext('Typ výpisu'), column: 'sShowVariant'},
          {id: 4, name: this.$gettext('Typ carouselu'), column: 'sType'},
          {id: 5, name: this.$gettext('Počet položek'), column: 'sDashboardItemsCount'},
          {id: 6, name: this.$gettext('Váha'), column: 'sDefaultWeight'},
          {id: 7, name: this.$gettext('Tématická skupina'), column: 'sThematicGroup'},
          {id: 8, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
          {id: 9, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
        ]
			},
      sortingTableTitlesOperator() {
        return [
          {id: 1, name: this.$gettext('Název'), column: 'sName'},
          {id: 2, name: this.$gettext('Typ výpisu'), column: 'sShowVariant'},
          {id: 3, name: this.$gettext('Typ carouselu'), column: 'sType'},
          {id: 4, name: this.$gettext('Počet položek'), column: 'sDashboardItemsCount'},
          {id: 5, name: this.$gettext('Váha'), column: 'sWeight'},
          {id: 6, name: this.$gettext('Tématická skupina'), column: 'sThematicGroup'},
          {id: 7, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
          {id: 8, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
        ]
      },
      csvHeaders(){
        return this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
      },
		},
		methods: {
			saveFilterValues() {
				this.saveSearch(this.formFields.search)
				this.setUserSetting('show_variant', this.formFields.show_variant);
				this.setUserSetting('type', this.formFields.type);
				this.setUserSetting('thematic_group', this.formFields.thematic_group);
				this.setUserSetting('operator', this.formFields.operator);
			},
      loadAdditionalDefaults() {
        let anyChanges = false
        if (this.loadDefaultByKey('show_variant')) {
          anyChanges = true
        }
        if (this.loadDefaultByKey('type')) {
          anyChanges = true
        }
        if (this.loadDefaultByKey('thematic_group')) {
          anyChanges = true
        }
        if (this.loadDefaultByKey('operator') && this.showOperatorFilter) {
          anyChanges = true
        }
        return anyChanges
      },
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/dashboardCarousels/DashboardCarouselList.vue